import {useMemo} from 'react';

import {useBrands} from '../../provider/brands/brand-hook';

import {HelpLinkFeatureFlagEnum} from './feature-flag-const';
import {useFeatureFlag} from './use-feature-flag';

// The phone description rolls out brand by brand: a company card knows the brand it belongs to and
// asks about that one.
export function usePhoneDescriptionEnabled(brandIds: Array<number> | null): boolean {
    return useFeatureFlag(HelpLinkFeatureFlagEnum.phoneDescription, brandIds);
}

// A bulk screen never resolves its selection down to single brands, so it asks about every brand the
// user can reach and opens the field as soon as one of them has the feature.
export function usePhoneDescriptionEnabledForUserBrands(): boolean {
    const {brands} = useBrands();

    const brandIds = useMemo(() => brands.map((brand) => brand.id), [brands]);

    return usePhoneDescriptionEnabled(brandIds);
}
